<template>
  <div>
    <div
      v-if="loader.page || errors.alert"
      class="d-flex justify-content-center"
    >
      <LoaderLogo :loading="loader.page" />
      <Alert
        v-if="errors.alert"
        :title="LABEL.ERRORI.PREFIX"
        :description="LABEL.ERRORI[errors.alert]"
        :btn="{
          label: LABEL.ERRORI.TRY_AGAIN,
          icon: 'undo',
          action: () => this.$router.go(),
        }"
      />
    </div>
    <section v-if="!loader.page && !errors.alert">
      <header>
        <h5
          class="text-gray-900 font-weight-bold d-flex"
          style="margin-bottom: 25px"
        >
          <font-awesome-icon icon="handshake" class="mr-2" />
          <span>{{
            userDetails
              ? LABEL.RICHIESTE.WELCOME(userDetails.codiceFiscale)
              : ""
          }}</span>
        </h5>
      </header>
      <article class="SisrCard br-10 container-card shadow-sm">
        <header class="text-gray-800">
          <h6 class="font-weight-bold">
            <font-awesome-icon icon="calendar-alt" class="mr-2" />
            {{ LABEL.RICHIESTE.CARD_TITLE }}
          </h6>
        </header>
        <List
          v-if="!!richieste.length"
          :items="richieste"
          :itemButton="button"
        />
        <div v-else>{{ LABEL.RICHIESTE.NO_REQUESTS }}</div>
      </article>
    </section>
  </div>
</template>

<script>
import { richiesteMixin } from "../../libs/mixins/application";

export default {
  mixins: [richiesteMixin],
};
</script>
